import { useEffect } from "react";

const SITE = "TradieLoop";
const DEFAULT_DESC = "TradieLoop connects Australian builders with sole-trader tradies for last-minute site work. Tradies post availability, builders send offers, Stripe escrow protects both sides.";

function upsert(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) { el = document.createElement(attrs.tag || "meta"); document.head.appendChild(el); }
  Object.entries(attrs).forEach(([k, v]) => { if (k !== "tag" && v != null) el.setAttribute(k, v); });
  return el;
}

// Per-page <head>: title, description, canonical, Open Graph / Twitter, robots, optional JSON-LD.
export default function useSEO(opts) {
  const { title, description = DEFAULT_DESC, path, image = "/og-image.png", noindex = false, jsonLd = null, type = "website" } = opts || {};
  useEffect(() => {
    if (!opts) return;
    const origin = window.location.origin;
    const url = `${origin}${path ?? window.location.pathname}`;
    const fullTitle = title ? (title.startsWith(SITE) ? title : `${title} | ${SITE}`) : `${SITE} — last-minute tradies, on site by tomorrow`;
    const img = image.startsWith("http") ? image : `${origin}${image}`;
    document.title = fullTitle;
    upsert('meta[name="description"]', { name: "description", content: description });
    upsert('meta[name="robots"]', { name: "robots", content: noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large" });
    upsert('link[rel="canonical"]', { tag: "link", rel: "canonical", href: url });
    [["og:site_name", SITE], ["og:type", type], ["og:title", fullTitle], ["og:description", description], ["og:url", url], ["og:image", img], ["og:locale", "en_AU"]]
      .forEach(([p, c]) => upsert(`meta[property="${p}"]`, { property: p, content: c }));
    [["twitter:card", "summary_large_image"], ["twitter:title", fullTitle], ["twitter:description", description], ["twitter:image", img]]
      .forEach(([n, c]) => upsert(`meta[name="${n}"]`, { name: n, content: c }));
    let ld = document.head.querySelector('script[data-seo-jsonld]');
    if (jsonLd) {
      if (!ld) { ld = document.createElement("script"); ld.type = "application/ld+json"; ld.setAttribute("data-seo-jsonld", "1"); document.head.appendChild(ld); }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) ld.remove();
  }, [title, description, path, image, noindex, type, JSON.stringify(jsonLd)]); // eslint-disable-line react-hooks/exhaustive-deps
}
